import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { PropsWithChildren, ReactNode } from 'react';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import Icon from '@mdi/react';
import { mdiAlertCircleOutline } from '@mdi/js';
import Loader from '@shared/components/Loader.tsx';

interface ISuspenseQueryErrorHandling extends PropsWithChildren {
    loader?: ReactNode;
    errorMessage?: string;
}

interface IErrorComponent {
    errorMessage?: string;
    reset: () => void;
}

const ErrorComponent = ({ errorMessage, reset }: IErrorComponent) => {
    return (
        <div className='alert alert- alert-danger  p-3'>
            <div className='alert-body d-flex flex-wrap gap-2'>
                <Icon
                    path={mdiAlertCircleOutline}
                    className='mdi'
                />
                <div className='d-flex flex-wrap flex-column flex-1'>
                    <p>{errorMessage ?? 'Något gick fel'}</p>
                    <p>
                        Vid akuta frågor kontakta oss på:{' '}
                        <a
                            href='tel:010-480 30 00'
                            className='text-nowrap'
                        >
                            010-480 30 00
                        </a>
                        .
                    </p>
                    <div>
                        <button
                            className='btn btn-sm btn-alert-danger'
                            onClick={reset}
                        >
                            Prova igen
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export function SuspenseQueryErrorHandling({ children, loader, errorMessage }: ISuspenseQueryErrorHandling) {
    return (
        <QueryErrorResetBoundary>
            {({ reset }) => (
                <ErrorBoundary
                    FallbackComponent={({ resetErrorBoundary }) => (
                        <ErrorComponent
                            reset={resetErrorBoundary}
                            errorMessage={errorMessage}
                        />
                    )}
                    onReset={reset}
                >
                    <Suspense fallback={loader ? loader : <Loader />}>{children}</Suspense>
                </ErrorBoundary>
            )}
        </QueryErrorResetBoundary>
    );
}
